import { DateTime } from "luxon";
import { formatConfig } from "@/config/format";

const padTimePart = (value: any) => String(value ?? "0").padStart(2, "0");

export const parseTimeToMinutes = (value: any): number => {
  if (value == null || value === "") return Number.MAX_SAFE_INTEGER;

  if (typeof value === "object") {
    const hours = Number(value.hours);
    const minutes = Number(value.minutes);
    if (Number.isNaN(hours)) return Number.MAX_SAFE_INTEGER;
    return hours * 60 + (Number.isNaN(minutes) ? 0 : minutes);
  }

  const [hoursPart, minutesPart] = String(value).split(":");
  const hours = Number(hoursPart);
  const minutes = Number(minutesPart);
  if (Number.isNaN(hours)) return Number.MAX_SAFE_INTEGER;
  return hours * 60 + (Number.isNaN(minutes) ? 0 : minutes);
};

export const resourceInitMinutes = (resource: any): number =>
  parseTimeToMinutes(resource?.init_hour ?? resource?.initHour);

export const formatHourValue = (value: any): string => {
  if (value == null || value === "") return "";

  if (typeof value === "object") {
    if (value.hours == null || value.hours === "") return "";
    return `${padTimePart(value.hours)}:${padTimePart(value.minutes ?? 0)}`;
  }

  const [hours, minutes] = String(value).split(":");
  if (hours == null || hours === "" || Number.isNaN(Number(hours))) return "";
  return `${padTimePart(hours)}:${padTimePart(minutes ?? 0)}`;
};

export const formatDisplayDate = (date: any): string => {
  if (!date) return "";

  if (date instanceof Date) {
    const fromJs = DateTime.fromJSDate(date);
    return fromJs.isValid ? fromJs.toFormat(formatConfig.dateFormat) : "";
  }

  const value = String(date);
  const iso = DateTime.fromISO(value, { zone: "utc" });
  if (iso.isValid) return iso.toFormat(formatConfig.dateFormat);

  const fromFormat = DateTime.fromFormat(value, formatConfig.dateFormat);
  return fromFormat.isValid ? fromFormat.toFormat(formatConfig.dateFormat) : "";
};

export const itemScheduleLabel = (
  item: any,
  options: { type?: string; fallbackDate?: any } = {}
): string => {
  const type = options.type || "";
  const startDate = formatDisplayDate(
    item?.checkin_date || item?.initDate || item?.date || options.fallbackDate
  );
  const endDate = formatDisplayDate(item?.endDate || item?.end_date || item?.checkout_date);
  const initHour = formatHourValue(item?.init_hour ?? item?.initHour);
  const endHour = formatHourValue(item?.end_hour ?? item?.endHour);

  const start = [startDate, initHour].filter(Boolean).join(" ");
  const end = type === "hotel" || type === "refuge" ? [endDate, endHour].filter(Boolean).join(" ") : endHour;

  if (start && end) return `${start} – ${end}`;
  return start || end;
};

export const resourceOverviewSchedules = (
  items: any[] = [],
  options: { type?: string; fallbackDate?: any } = {}
): string[] => {
  const labels = [...items]
    .sort((a, b) => resourceInitMinutes(a) - resourceInitMinutes(b))
    .map((item) => itemScheduleLabel(item, options))
    .filter(Boolean);

  return [...new Set(labels)];
};
